import { useState } from "react";
import { Dialog } from "@headlessui/react";
import NutritionForm from "./NutritionForm";
import NutritionFormWithoutLimits from "./NutritionFormWithoutLimits";

function MacrosCalculator() {
  const [openModal, setOpenModal] = useState(null);
  // null = ninguno, "nutrition" = NutritionForm, "extended" = NutritionFormExtended

  return (
    <div className="min-h-full">
      <div className="py-10">
        <header>
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <h1 className="text-3xl font-bold leading-tight tracking-tight text-gray-900">
              Calculate Nutrition Requirements of the Athlete
            </h1>
          </div>
        </header>

        <main>
          <div className="mx-auto max-w-7xl sm:px-6 lg:px-8">
            <div className="flex gap-4 my-6">
              <button
                className="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              
                onClick={() => setOpenModal("nutrition")}
              >
                Open calculator with limits
              </button>

              <button
                className="rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600"
              
                onClick={() => setOpenModal("extended")}
              >
                Open calculator without limits
              </button>
            </div>

            {/* Modal */}
            <Dialog
              open={openModal !== null}
              onClose={() => setOpenModal(null)}
              className="relative z-50"
            >
              {/* Fondo oscuro */}
              <div className="fixed inset-0 bg-black/40" aria-hidden="true" />

              {/* Contenido centrado */}
              <div className="fixed inset-0 flex items-center justify-center p-4">
                <Dialog.Panel
                  className="mx-auto w-full max-w-5xl rounded-xl bg-white p-6 shadow-xl"
                >
                  <Dialog.Title className="text-xl font-bold mb-4">
                    {openModal === "nutrition"
                      ? "Calculate Nutrition Requirements with Limits"
                      : "Calculate Nutrition Requirements without Limits"}
                  </Dialog.Title>

                  {/* Contenido con scroll interno */}
                  <div className="max-h-[80vh] overflow-y-auto pr-2 modal-scrollable">
                    {openModal === "nutrition" && <NutritionForm />}
                    {openModal === "extended" && <NutritionFormWithoutLimits />}
                  </div>

                  {/* Footer con botón de cierre */}
                  <div className="mt-6 flex justify-end">
                    <button
                      className="px-4 py-2 bg-gray-300 rounded-lg hover:bg-gray-400"
                      onClick={() => setOpenModal(null)}
                    >
                      Close
                    </button>
                  </div>
                </Dialog.Panel>
              </div>
            </Dialog>
          </div>
        </main>
      </div>
    </div>
  );
}

export default MacrosCalculator;
